exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Faq .btn-toggle {\n  margin: 5px 0;\n  font-weight: bold;\n  border-color: #cccccc; }\n  .Faq .btn-toggle:hover, .Faq .btn-toggle:active, .Faq .btn-toggle.active, .Faq .btn-toggle:hover:active {\n    background-color: #0b6ae1 !important;\n    border-color: #0b6ae1 !important; }\n  .Faq .btn-toggle:focus, .Faq .btn-toggle:focus:active, .Faq .btn-toggle:active {\n    -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5) !important;\n            box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5) !important; }\n\n.Faq .accordion-content {\n  padding: 0; }\n\n.Faq .qa-question {\n  font-size: 15px;\n  margin-bottom: 0 !important; }\n\n.Faq .qa-content {\n  margin: 20px 0;\n  padding: 20px; }\n  .Faq .qa-content:nth-child(even) {\n    background-color: #f7fafd; }\n\n.Faq .qa-answer {\n  margin-top: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/containers/FaqList.scss
// module id = 584
// module chunks = 0